import { DynamicFormV2Palette } from "@mui/material";

export type FormSkeletonComponentTokenType = {
  darkBackgroundColor: string;
  lightBackgroundColor: string;
};

export const assignSkeletonComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    darkBackgroundColor: formsPalette.surface.moderate,
    lightBackgroundColor: isLightMode ? formsPalette.surface.moderate : formsPalette.surface.supershy,
  } as FormSkeletonComponentTokenType;
};
